import { render, staticRenderFns } from "./SuppliersSenderModal.vue?vue&type=template&id=5622ba80&scoped=true&"
import script from "./SuppliersSenderModal.vue?vue&type=script&lang=js&"
export * from "./SuppliersSenderModal.vue?vue&type=script&lang=js&"
import style0 from "./SuppliersSenderModal.vue?vue&type=style&index=0&id=5622ba80&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5622ba80",
  null
  
)

export default component.exports